/**
 * SkinControl class helper.
 * @name com.inq.flash.client.chatskins.AccessibilityHelp
 * @class
 * @public
 * @constructor
 */
com.inq.flash.client.chatskins.AccessibilityHelp = function () {
    this.reset();
};

$hxClasses.registerClass(com.inq.flash.client.chatskins.AccessibilityHelp, "com.inq.flash.client.chatskins.AccessibilityHelp");

/**
 * Reset the {com.inq.flash.client.chatskins.AccessibilityHelp} to the initial state.
 * @public
 * @returns {void}
 */
com.inq.flash.client.chatskins.AccessibilityHelp.prototype.reset = function () {
    this.btnSendOriginalTitle = "";
    this.isAccessibilityHelpOnBtnSend = false;
    this.isButtonHasFirstFocus = false;
    this.isAddHelpOnBtnSendCalled = false;
    this.isAccessibilityHelpUsed = false;
};

/**
 * applyHelpOnBtnSend - is used to add help on "Send" button or restore states of the "Send" button
 * if previously help was added for this button.
 */
com.inq.flash.client.chatskins.AccessibilityHelp.prototype.applyHelpOnBtnSend = function () {
	if (this.isAddHelpOnBtnSendCalled) {
		this.restoreHelpOnBtnSend();
	} else {
		this.addHelpOnBtnSend();
	}
};

/**
 * Set Send button as 'start chat button'
 * @public
 * @returns {void}
 */
com.inq.flash.client.chatskins.AccessibilityHelp.prototype.addHelpOnBtnSend = function () {
    // if an opener script is claiming focus, we do not want to add this
    if (com.inq.flash.client.chatskins.SkinControl.initialFocusClaimedBy) {
        return;
    }
    var btnSendP = com.inq.flash.client.chatskins.SkinControl.getSendButton();
    var that = com.inq.flash.client.chatskins.AccessibilityHelp;
    that.removeHelpOnBtnSendCallback = this.removeHelpOnBtnSend.bind(this); // save context

    // Make sure this function is called only once.
    if (this.isAddHelpOnBtnSendCalled) {
        return;
    }
    this.isAddHelpOnBtnSendCalled = true;

    if (btnSendP && btnSendP._img) {
        /* add conditions to avoid title and alt overwritten with a new value when they are called twice. */
		if (!this.btnSendOriginalTitle && btnSendP._img.hasAttribute("title")) {
			this.btnSendOriginalTitle = btnSendP._img.getAttribute("title");
        }

		btnSendP._img.setAttribute("title", "Start Chat. Double tap to start editing mode");
        btnSendP._img.addEventListener("blur", that.removeHelpOnBtnSendCallback, false);

		this.setFocusOnBtnSend();

        this.isAccessibilityHelpOnBtnSend = true;
		this.isButtonHasFirstFocus = true;
    }
};

/**
 * restoreHelpOnBtnSend - is used to restore all necessary states of the "Send" button if
 * previously "addHelpOnBtnSend" was called.
 */
com.inq.flash.client.chatskins.AccessibilityHelp.prototype.restoreHelpOnBtnSend = function () {
	if (this.isAccessibilityHelpOnBtnSend && !this.isAccessibilityHelpUsed) {
		this.setFocusOnBtnSend();
	}
};

/**
 * Sets focus on the button "Send"
 * We add a little timeout to set the focus on the button in the phones, because they need more time to render
 * the components of the page, and therefore the focus cannot be set to an element that has not been rendered.
 */
com.inq.flash.client.chatskins.AccessibilityHelp.prototype.setFocusOnBtnSend = function () {
	/** @type {com.inq.ui.Button} */
	var btnSend = com.inq.flash.client.chatskins.SkinControl.getSendButton();

	if (!btnSend) {
		return;
	}

	if (com.inq.utils.Capabilities.isPhone()) {
		setTimeout(function() {
			btnSend.setImageFocus();
		}, 100);
	} else {
		btnSend.setImageFocus();
	}
};

/**
 * Remove accessibility help and reset to original Send button.
 * @public
 * @returns {void}
 */
com.inq.flash.client.chatskins.AccessibilityHelp.prototype.removeHelpOnBtnSend = function () {

	// Make sure that this function can be called only after addHelpOnBtnSend
	if (!this.isAccessibilityHelpOnBtnSend) {
		return;
	}

    var that = com.inq.flash.client.chatskins.AccessibilityHelp;
    var btnSendP = com.inq.flash.client.chatskins.SkinControl.getSendButton();
	if (this.btnSendOriginalTitle) {
		btnSendP._img.setAttribute("title", this.btnSendOriginalTitle);
	} else {
		btnSendP._img.removeAttribute("title");
	}
    btnSendP._img.removeEventListener("blur", that.removeHelpOnBtnSendCallback, false);
    this.isAccessibilityHelpOnBtnSend = false;
    this.isAccessibilityHelpUsed = true;
    that.removeHelpOnBtnSendCallback = null;
};

/**
 * Factory, creates new instance of AccessibilityHelp.
 * @public
 * @static
 * @returns {com.inq.flash.client.chatskins.AccessibilityHelp}
 */
com.inq.flash.client.chatskins.AccessibilityHelp.createInstance = function () {
    return new com.inq.flash.client.chatskins.AccessibilityHelp;
};

/** @type {String} */
com.inq.flash.client.chatskins.AccessibilityHelp.prototype.btnSendOriginalTitle = "";
/** @type {Boolean} */
com.inq.flash.client.chatskins.AccessibilityHelp.prototype.isAccessibilityHelpOnBtnSend = false;
/** @type {Boolean} To solve text input rendering issue on phone. */
com.inq.flash.client.chatskins.AccessibilityHelp.prototype.isButtonHasFirstFocus = false;
/** @type {Boolean} Make sure help is used only once. */
com.inq.flash.client.chatskins.AccessibilityHelp.prototype.isAddHelpOnBtnSendCalled = false;
/** @type {Boolean} Indicate that ada help on send button is used */
com.inq.flash.client.chatskins.AccessibilityHelp.prototype.isAccessibilityHelpUsed = false;
/** @private @static @type {Function} */
com.inq.flash.client.chatskins.AccessibilityHelp.removeHelpOnBtnSendCallback = null;
